import Cookies from "js-cookie";
import { Message } from "element-ui";

const TokenKey = "token";
const LoginApiPaths = ["/user/loginAndAuth", "/login/"];
const AuthInvalidCode = [10061, 10062, 10063, 10064, 10065, 10066, 10067]; // token 过期或无效错误码
let isRedirectingToLogin = false;
let hasShownAuthExpiredMessage = false;

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function isLoginRequest(url = "") {
  return LoginApiPaths.some((path) => url.includes(path));
}

export function isAuthInvalidCode(code) {
  return AuthInvalidCode.includes(Number(code));
}

export function clearAuthState() {
  const cookies = document.cookie.split(";");
  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

    if (!name) {
      return;
    }

    Cookies.remove(name);
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });

  localStorage.clear();
  sessionStorage.clear();
}

export function redirectToLogin() {
  if (window.location.pathname === "/login") {
    return;
  }

  if (isRedirectingToLogin) {
    return;
  }

  isRedirectingToLogin = true;
  window.location.replace("/login");
}

export function handleAuthExpired() {
  if (!hasShownAuthExpiredMessage) {
    hasShownAuthExpiredMessage = true;
    Message({
      type: "warning",
      message: "登录已失效，请重新登录",
      duration: 2000,
    });
  }
  clearAuthState();
  window.setTimeout(() => {
    redirectToLogin();
  }, 300);
}
